export default "__VITE_ASSET__CJipD5bq__"